<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}

.theme--light.v-table tbody tr:not(:last-child) {
  cursor: pointer;
  border-bottom: 0;
}
</style>

<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">book</v-icon>
          Switch Customer
        </h3>
        Here you can switch to a different customer account.
        <blockquote>
          Please use the button to select your customer account.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout row wrap pb-0 elevation-3>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="customerList"
          :must-sort="true"
          class="elevation-0"
          hide-actions
        >
          <template v-slot:items="{ item: customer }">
            <tr
              :class="{
                'green--text': customer.id === activeCustomerId
              }"
            >
              <td>{{ customer.number }}</td>
              <td>{{ customer.divisionLabel }}</td>
              <!-- <td>
                <span v-if="customer.division == '01'">Consumer</span>
                <span v-if="customer.division == '02'">Scientific</span>
                <span v-if="customer.division == '03'">Healthcare</span>
              </td> -->
              <td>
                <address-name-format
                  :names="[customer.name1, customer.name2, customer.name3]"
                ></address-name-format>
              </td>
              <td>{{ customer.street }}</td>
              <td>{{ customer.city }}</td>
              <td>{{ customer.country }}</td>

              <td>
                <v-layout justify-start v-if="customer.id === activeCustomerId">
                  <v-btn
                    class="ma-0 elevation-5 green green--text"
                    small
                    outline
                  >
                    <v-icon size="20px" class="pr-1">check_circle</v-icon>
                    Current Customer
                  </v-btn>
                </v-layout>
                <v-layout justify-start v-else>
                  <v-btn
                    @click="onSelectCustomer(customer.id)"
                    class="ma-0"
                    color="blue"
                    small
                    outline
                  >
                    <v-icon size="20px" class="pr-1">supervisor_account</v-icon>
                    Select Customer
                  </v-btn>
                </v-layout>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AddressNameFormat from "@/components/AddressNameFormat.vue";

export default {
  components: {
    AddressNameFormat
  },
  data() {
    return {
      headers: [
        {
          text: "No.",
          value: "number"
        },
        {
          text: "Category",
          value: "divisionLabel"
        },
        {
          text: "Name",
          value: "name1"
        },
        {
          text: "Street",
          value: "street"
        },
        {
          text: "City",
          value: "city"
        },
        {
          text: "Country",
          value: "country"
        },
        {
          text: "",
          sortable: false
        }
      ]
    };
  },
  computed: mapGetters("user", {
    customerList: "getCustomerList",
    activeCustomerId: "getActiveCustomerId"
  }),
  methods: {
    onSelectCustomer(customerId) {
      this.$store.dispatch("user/changeActiveCustomer", { customerId });
      this.$store.dispatch("customer/switchCustomer", { customerId });
    }
  }
};
</script>
